import { Base } from "../Base";
export class Class extends Base {
    name;
    class = "function";
    constructor(name = "function") {
        super();
        this.name = name;
    }
    is(value) {
        return typeof value == "function";
    }
    static create(name) {
        return new Class(name);
    }
}
//# sourceMappingURL=Class.js.map